<div class="rsp">

  <div class="rsp-message" *ngIf="isLoading">Loading&hellip;</div>

  <div class="rsp-message rsp-error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</div>

  <!--
    A pie divides a whole into parts. An export hour is a negative part, which has no share of
    anything, so the breakdown is refused and said out loud. The bar view shows the same window
    correctly, which is why that is what this points at.
  -->
  <div class="rsp-message" *ngIf="!isLoading && !errorMessage && hasNegativeValues">
    This window includes exported energy, so it cannot be split into shares of a whole.
    Use the bar view to see it.
  </div>

  <div class="rsp-message"
       *ngIf="!isLoading && !errorMessage && !hasNegativeValues && !slices.length">
    Nothing was recorded in this window.
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && !hasNegativeValues && slices.length">

    <div class="rsp-body">

      <div class="rsp-plot" #plot>
        <ngx-charts-pie-chart
          [view]="view"
          [results]="chartData"
          [scheme]="colours"
          [doughnut]="true"
          [arcWidth]="0.4"
          [labels]="false"
          [legend]="false"
          [tooltipDisabled]="false">
        </ngx-charts-pie-chart>

        <!--
          The middle of a doughnut is the one place the total can sit without competing with a
          slice. The SSRS pie has nowhere to put it, so the total is never on screen there at all.
        -->
        <div class="rsp-centre">
          <div class="rsp-centre-value">{{ format(centreValue) }}</div>
          <div class="rsp-centre-unit">{{ unit }}</div>
          <div class="rsp-centre-note" *ngIf="isAverage">average</div>
        </div>
      </div>

      <!--
        Our own legend rather than the built-in one, so each row carries the figure and the share
        beside the name. Reading a percentage off a wedge is the thing people complain about in the
        current chart.
      -->
      <ul class="rsp-legend">
        <li class="rsp-legend-row" *ngFor="let slice of slices; trackBy: trackBySlice">
          <span class="rsp-swatch" [style.background]="slice.rgb"></span>
          <span class="rsp-legend-name" [title]="slice.name">{{ slice.name }}</span>
          <span class="rsp-legend-value">{{ format(slice.value) }} {{ unit }}</span>
          <span class="rsp-legend-percent">{{ slice.percent | number:'1.0-1' }}%</span>
        </li>
      </ul>

    </div>

  </ng-container>

</div>
